import { templateDataType } from "./template_sections";

// Import individual templates
import { listing_promo_var_1 } from "./templates/listing-promo-var-1";
import { just_sold_var_1 } from "./templates/just-sold-var-1";
import { new_listing_vertical_var_1 } from "./templates/new-listing-vertical-var-1";
import { property_collage_var_1 } from "./templates/property-collage-var-1";
import { area_highlight_var_1 } from "./templates/area-highlight-var-1";
import { modern_showcase_var_1 } from "./templates/modern-showcase-var-1";
import { hot_properties_duo_var_1 } from "./templates/hot-properties-duo-var-1";
import { sold_property_var_1 } from "./templates/sold-property-var-1";
import { sold_announcement_var_1 } from "./templates/sold-announcement-var-1";
import { property_highlight_var_1 } from "./templates/property-highlight-var-1";

export const creativeTemplates: templateDataType[] = [
  sold_announcement_var_1,
  property_highlight_var_1,
  sold_property_var_1,
  hot_properties_duo_var_1,
  modern_showcase_var_1,
  area_highlight_var_1,
  property_collage_var_1,
  new_listing_vertical_var_1,
  listing_promo_var_1,
  just_sold_var_1
];
